// infcode_change - metrics foundation
import * as Log from "@opencode-ai/core/util/log"
import { MetricsClient, type EventSpec } from "./client"

const LOG_PREFIX = "[metrics:api]"
const log = Log.create({ service: LOG_PREFIX })

type Recorder = (spec: EventSpec) => unknown

let recorder: Recorder = MetricsClient.tryRecord

export namespace Metrics {
  export function pageView(input: Omit<Extract<EventSpec, { kind: "page_view" }>, "kind">) {
    emit({ kind: "page_view", ...input })
  }

  export function performance(input: Omit<Extract<EventSpec, { kind: "performance" }>, "kind">) {
    emit({ kind: "performance", ...input })
  }

  export function error(input: Omit<Extract<EventSpec, { kind: "error" }>, "kind">) {
    emit({ kind: "error", ...input })
  }

  export function panic(input: Omit<Extract<EventSpec, { kind: "panic" }>, "kind">) {
    emit({ kind: "panic", ...input })
  }

  export async function shutdown() {
    await MetricsClient.shutdown().catch(() => {})
  }

  /** 送出已入队事件但不停用记录器；关闭链路中间阶段用它，见 MetricsClient.flush。 */
  export async function flush() {
    await MetricsClient.flush().catch(() => {})
  }

  export function tryRecord(spec: EventSpec): boolean {
    try {
      return recorder(spec) !== false
    } catch (err) {
      log.debug("metrics emit failed", { error: err instanceof Error ? err.message : String(err) })
      return false
    }
  }

  export function configureForTest(input: Recorder) {
    recorder = input
  }

  export function resetForTest() {
    recorder = MetricsClient.tryRecord
  }
}

function emit(spec: EventSpec) {
  Metrics.tryRecord(spec)
}
